
const { ccclass, property } = cc._decorator;

@ccclass
export default class TalkMessageItem extends cc.Component {

    @property(cc.Label)
    lbMessageText: cc.Label = null;
    @property(cc.Label)
    lbName:cc.Label = null;
    @property(cc.Node)
    ndBg: cc.Node = null;


   setMessageText(text: string, name: string, time: string){
       this.lbMessageText.string = text;
       this.lbName.string = `${name} ${time}`;
   }

    protected updateContentSize(isMuit: boolean) { 

    }

    // update (dt) {}
}
